import Cookies from 'js-cookie';

const cookieKey = 'cookieAssess';
export const getCookiesSite = () => Cookies.get(cookieKey);
export const setCookiesSite = (cookie: string) => Cookies.set(cookieKey, cookie, { expires: 364 });

const languageKey = 'language';
export const getLanguage = () => Cookies.get(languageKey);
export const setLanguage = (language: string) => Cookies.set(languageKey, language);

// TODO тимчасова заглушка: гейт демо-логіну для окремих доменів (sites.ts -> accessGate)
const gateAccessKey = 'gateAccess';
export const getGateAccess = () => Cookies.get(gateAccessKey);
export const setGateAccess = (value: string) => Cookies.set(gateAccessKey, value, { expires: 7 });

const gateBannedKey = 'gateBanned';
export const getGateBanned = () => Cookies.get(gateBannedKey);
export const setGateBanned = (value: string) => Cookies.set(gateBannedKey, value, { expires: 0.2 });

const getNotebookData = (fieldName: string) => window.sessionStorage.getItem(fieldName);
const setNotebookData = (fieldName: string, items: any) => window.sessionStorage.setItem(fieldName, JSON.stringify(items));
